import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowDownRight } from 'lucide-react';
import { Reveal, PageHero, SectionHeading, CTABand } from '../components/Shared';
import { founders, leadership, operations } from '../data/team';
import { L } from '../i18n/LocaleProvider';
import { TeamProfileCard } from '../components/team/TeamProfileCard';
import { TeamProfileModal } from '../components/team/TeamProfileModal';

const everyone = [...founders, ...leadership, ...operations];

export default function Team() {
  const [openIndex, setOpenIndex] = useState(null);
  const open = member => setOpenIndex(everyone.findIndex(m => m.id === member.id));
  const step = delta => setOpenIndex(current => (current === null ? null : (current + delta + everyone.length) % everyone.length));

  return <L><main id="main-content" className="team-page" data-testid="team-page">
    <PageHero id="team-hero" eyebrow="OUR PEOPLE. OUR DIFFERENCE." lines={[{ text: 'The people behind' }, { text: 'what’s next.', accent: true }]} description="Meet the people bringing innovation together.">
      <Reveal className="team-chapter-links" delay={.35}><Link to="#leadership" data-testid="team-jump-leadership">Leadership <ArrowDownRight size={15} /></Link><Link to="#operations" data-testid="team-jump-operations">Operations & Delivery <ArrowDownRight size={15} /></Link></Reveal>
    </PageHero>
    <section className="container team-founders" aria-label="TechSpitze founders"><div className="team-founders-grid">{founders.map((member, i) => <TeamProfileCard key={member.id} member={member} index={i} founder onOpen={open} />)}</div></section>
    <section id="leadership" className="container section team-leadership">
      <SectionHeading id="team-leadership" eyebrow="LEADERSHIP" title="A shared vision." />
      <div className="team-grid">{leadership.map((member, i) => <TeamProfileCard key={member.id} member={member} index={i} group="leadership" onOpen={open} />)}</div>
    </section>
    <section id="operations" className="container section team-operations">
      <SectionHeading id="team-operations" eyebrow="OPERATIONS & DELIVERY" title="Hands-on delivery." />
      <div className="team-grid operations-grid">{operations.map((member, i) => <TeamProfileCard key={member.id} member={member} index={i} group="operations" onOpen={open} />)}</div>
    </section>
    <CTABand id="team-cta" title={<>Your ambition.<br />Meet your team.</>} />
    {openIndex !== null && <TeamProfileModal member={everyone[openIndex]} onClose={() => setOpenIndex(null)}
      onPrev={() => step(-1)} onNext={() => step(1)} position={`${openIndex + 1} / ${everyone.length}`} />}
  </main></L>;
}
